<!-- ===== CONTENIDO ===== -->

<div class="contenido">

  <h2>CONTABILIDAD INSTITUCIONAL</h2>

  <!-- ===== TABS ===== -->
  <ul class="nav nav-tabs custom-tabs">

    <li><button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">ESTADOS FINANCIEROS</button></li>

    <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">ESTADOS CONTABLES</button></li>

    <li><button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">TECNM CAMPUS ESCARCEGA</button></li>



  </ul>

  <!-- ===== CONTENIDO DE TABS ===== -->
  <div class="tab-content box-content">

    <!-- TAB 1 -->
    <div class="tab-pane fade show active" id="tab1">

      <div class="anio-card" *ngFor="let anio of data">

  <!-- AÑO -->
  <div class="anio-header" (click)="anio.abierto = !anio.abierto">
    📁 Presupuesto {{anio.anio}}
  </div>

  <div *ngIf="anio.abierto" class="anio-body">

    <!-- PRESUPUESTOS -->
    <ul class="docs-list">
      <li *ngFor="let p of anio.presupuestos">
        <img src="assets/vinculacion/pdf.png">
        <a [href]="p.url" target="_blank">
          {{p.nombre}}
        </a>
      </li>
    </ul>

    <!-- TRIMESTRES -->
    <div class="trimestre" *ngFor="let t of anio.trimestres">

      <div class="trimestre-header" (click)="t.abierto = !t.abierto">
        📂 {{t.nombre}}
      </div>

      <div *ngIf="t.abierto">

        <!-- CARPETAS -->
        <div class="subcarpeta" *ngFor="let c of t.carpetas">

          <div class="subcarpeta-header" (click)="c.abierto = !c.abierto">
            📁 {{c.nombre}}
          </div>

          <!-- ARCHIVOS -->
          <ul *ngIf="c.abierto">
            <li *ngFor="let doc of c.archivos">
              <img src="assets/vinculacion/pdf.png">
              <a [href]="doc.url" target="_blank">
                {{doc.nombre}}
              </a>
            </li>
          </ul>

        </div>

      </div>

    </div>

  </div>

</div>

    </div>

    <!-- TAB 2 -->
    <div class="tab-pane fade" id="tab2">

      <h5>ESTADOS CONTABLES</h5>

      <ul class="pdf-list">

        <p>Inventario 2026</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2026/RELACION DE BIENES MUEBLES E INMUEBLES AL 30 DE JUNIO.pdf" target="_blank">RELACION DE BIENES MUEBLES E INMUEBLES AL 30 DE JUNIO</a></li>
        <br><br>
        <p>Inventario 2025</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2025/Inventario Bienes Muebles e Inmuebles al 30 de Junio.pdf" target="_blank">Inventario Bienes Muebles e Inmuebles al 30 de Junio</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2025/Inventario Bienes Muebles e Inmuebles al 31 de Diciembre.pdf" target="_blank">Inventario Bienes Muebles e Inmuebles al 31 de Diciembre</a></li>
        <br><br>
          <p>Inventario 2024</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2024/Relacion Bienes Muebles e Inmuebles al 30 Junio.pdf" target="_blank">Relacion Bienes Muebles e Inmuebles al 30 Junio</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2024/Relacion Bienes Muebles e Inmuebles al 31 Diciembre.pdf" target="_blank">Relacion Bienes Muebles e Inmuebles al 31 Diciembre</a></li>
        <br><br>
          <p>Inventario 2023</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2023/INVENTARIO DE BIENES MUEBLES E INMUEBLES AL 30 DE JUNIO 2023.pdf" target="_blank">INVENTARIO DE BIENES MUEBLES E INMUEBLES AL 30 DE JUNIO 2023</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2023/REPORTE DE BIENES MUEBLES E INMUEBLES AL 31 DE DICIEMBRE 2023.pdf" target="_blank">REPORTE DE BIENES MUEBLES E INMUEBLES AL 31 DE DICIEMBRE 2023</a></li>
        <br><br>
          <p>Inventario 2022</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2022/INVENTARIO DE BIENES MUEBLES E INMUEBLES AL 30 DE JUNIO 2022.pdf" target="_blank">INVENTARIO DE BIENES MUEBLES E INMUEBLES AL 30 DE JUNIO 2022</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2022/REPORTE DE BIENES MUEBLES E INMUEBLES AL 31 DIC 2022.pdf" target="_blank">REPORTE DE BIENES MUEBLES E INMUEBLES AL 31 DIC 2022</a></li>
        <br><br>
          <p>Inventario 2021</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2021/BIENES MUEBLES E INMUEBLES AL 31 DIC 2021.pdf" target="_blank">BIENES MUEBLES E INMUEBLES AL 31 DIC 2021</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2021/INVENTARIO DE BIENES MUEBLES E INMUEBLES AL 30 DE JUNIO 2021.pdf" target="_blank">INVENTARIO DE BIENES MUEBLES E INMUEBLES AL 30 DE JUNIO 2021</a></li>
        <br><br>
          <p>Inventario 2020</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2020/LIBRO DE INVENTARIO DE BIENES MUEBLES E INMUEBLES AL 31 DE DICIEMBRE 2020.pdf" target="_blank">LIBRO DE INVENTARIO DE BIENES MUEBLES E INMUEBLES AL 31 DE DICIEMBRE 2020</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2020/RELACION DE BIENES MUEBLES E INMUEBLES AL 30 JUNIO.pdf" target="_blank">RELACION DE BIENES MUEBLES E INMUEBLES AL 30 JUNIO</a></li>
        <br><br>
          <p>Inventario 2019</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2019/BIENES INMUEBLES  DICIEMBRE 2019.pdf" target="_blank">BIENES INMUEBLES  DICIEMBRE 2019</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2019/BIENES INMUEBLES AL 30 DE JUNIO 19.pdf" target="_blank">BIENES INMUEBLES AL 30 DE JUNIO 19</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2019/BIENES MUEBLES DICIEMBRE-2019.pdf" target="_blank">BIENES MUEBLES DICIEMBRE-2019</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2019/INVENTARIO DE BIENES MUEBLES AL 30 DE JUNIO 19.pdf" target="_blank">INVENTARIO DE BIENES MUEBLES AL 30 DE JUNIO 19</a></li>
        <br><br>
           <p>Inventario 2018</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2018/Bienes inmuebles diciembre 2018.pdf" target="_blank">Bienes inmuebles diciembre 2018</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2018/Bienes muebles dic 2018.pdf" target="_blank">Bienes muebles dic 2018</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2018/Inmuebles Enero Julio 2018.pdf" target="_blank">Inmuebles Enero Julio 2018</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2018/Muebles Enero Junio 2018.pdf" target="_blank">Muebles Enero Junio 2018</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2018/INVENTARIO DE BIENES MUEBLES E INMUEBLES 2018.pdf" target="_blank">INVENTARIO DE BIENES MUEBLES E INMUEBLES 2018</a></li>
        <br><br>
         <p>Inventario 2017</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2017/BIENES INMUEBLES 2017.pdf" target="_blank">BIENES INMUEBLES 2017</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2017/Inmuebles Enero Diciembre 2017.pdf" target="_blank">Inmuebles Enero Diciembre 2017</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2017/INVENTARIO DE BIENES MUEBLES 2017.pdf" target="_blank">INVENTARIO DE BIENES MUEBLES 2017</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2017/Muebles Enero Diciembre 2017.pdf" target="_blank">Muebles Enero Diciembre 2017</a></li>
        <br><br>
         <p>Inventario 2016</p>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2016/1a-RBienes inmuebles diciembre 2016.pdf" target="_blank">1a-RBienes inmuebles diciembre 2016</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2016/2-Relación de bienes muebles.pdf" target="_blank">2-Relación de bienes muebles</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2016/2a-RBienesmuebles.pdf" target="_blank">2a-RBienesmuebles</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2016/Cuenta Publica Bienes Inmuebles 2016.pdf" target="_blank">Cuenta Publica Bienes Inmuebles 2016</a></li>
        <li><a href="assets/contabilidad_institucional/estados_contables/Inventario 2016/Cuenta Publica Bienes Muebles 2016.pdf" target="_blank">Cuenta Publica Bienes Muebles 2016</a></li>
        <br><br>

      </ul>
    </div>

    <!-- TAB 3 -->
    <div class="tab-pane fade" id="tab3">

      <h5>ITSE</h5>

      <ul class="pdf-list">
        <p>MANUAL DE ORGANIZACIÓN</p>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/manual_organizacion/Manual de Organización 2022.pdf" target="_blank">Manual de Organización 2022</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/manual_organizacion/Manual de Organizacion 2021.pdf" target="_blank">Manual de Organización 2021</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/manual_organizacion/Manual de Organizacion 2020.pdf" target="_blank">Manual de Organización 2020</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/manual_organizacion/Manual de Organizacion 2019.pdf" target="_blank">Manual de Organización 2019</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/manual_organizacion/Manual de Organizacion 2018.pdf" target="_blank">Manual de Organización 2018</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/manual_organizacion/Manual de Organizacion 2017.pdf" target="_blank">Manual de Organización 2017</a></li>
        <br><br>
        <p>MANUAL DE PROCEDIMIENTOS</p>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/manual_procedimientos/Manual de procedimientos 2021.pdf" target="_blank">Manual de procedimientos 2021</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/manual_procedimientos/Manual de procedimientos 2020.pdf" target="_blank">Manual de procedimientos 2020</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/manual_procedimientos/Manual de procedimientos 2019.pdf" target="_blank">Manual de Procedimientos 2019</a></li>
        <br><br>
        <p>ESTRUCTURA ORGÁNICA</p>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/estructura_organica/Estructura organica 2022.pdf" target="_blank">Estructura organica 2022</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/estructura_organica/Estructura organica 2021.pdf" target="_blank">Estructura organica 2021</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/estructura_organica/Estructura organica 2020.pdf" target="_blank">Estructura organica 2020</a></li>
        
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/estructura_organica/Estructura organica 2018.pdf" target="_blank">Estructura organica 2018</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/estructura_organica/Estructura organica 2017.pdf" target="_blank">Estructura organica 2017</a></li>
        <li><a href="assets/contabilidad_institucional/tecnm_campus_escarcega/estructura_organica/Estructura organica 2016.pdf" target="_blank">Estructura organica 2016</a></li>
        <br><br>
      </ul>
    </div>


  </div>

</div>